import { Themes } from '../../constants';
import { getThemeColor } from '../../utils/common';

interface RadioButtonUncheckedIconProps {
  theme: Themes;
}

const RadioButtonUncheckedIcon = (props: RadioButtonUncheckedIconProps) => {
  const { theme = Themes.Primary } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
      <rect x="1" y="1.5" width="18" height="18" rx="9" fill={getThemeColor(theme).light3} />
      <rect
        x="1"
        y="1.5"
        width="18"
        height="18"
        rx="9"
        stroke={getThemeColor(theme).primary}
        strokeWidth="2"
      />
    </svg>
  );
};

export default RadioButtonUncheckedIcon;
